/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { FORWARDING_RULE_ALGORITHM, ROUTE } from 'constant';
import Shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/helper';
import { isEmptyObject } from 'utils';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';

export default ({ match, history }) => {
  const id = match.params?.id;
  const { [ACTIONS_TYPES.TARGET_GROUP.GET]: targetGroup = {} } = useSelector((e) => e);
  const { properties = {} } = targetGroup;
  const { healthCheck = {}, httpHealthCheck = {}, targets = [] } = properties;

  useEffect(() => {
    actions.targetGroup.get({ id });
  }, [id]);

  const deleteHandler = () => {
    actions.targetGroup.delete({ id });
    history.push(ROUTE.DASHBOARD.TARGET_GROUPS.path);
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.TARGET_GROUP}
      strapIcon="bullseye"
      strapTitle={properties.name}
      strapSubTitle={(
        <>
          <span>{(FORWARDING_RULE_ALGORITHM[properties.algorithm] || {}).label}</span>
          <Shared.utilities.Separator />
          <span>{properties.protocol}</span>
        </>
      )}
      onDelete={deleteHandler}
      onEditClick={() => history.push(ROUTE.DASHBOARD.TARGET_GROUPS_CREATE.path.replace(':id', id))}
    >
      {!isEmptyObject(healthCheck) && (
        <Shared.widgets.Properties
          properties={[
            ['Client Timeout (ms)', healthCheck.checkTimeout],
            ['Check Interval (ms)', healthCheck.checkInterval],
            ['retries', healthCheck.retries],
          ]}
          title="Connection Settings"
        />
      )}

      {!isEmptyObject(httpHealthCheck) && (
        <Shared.widgets.Properties
          properties={[
            ['HTTP Path', httpHealthCheck.path],
            ['HTTP Method', httpHealthCheck.method],
            ['Response Match Type', httpHealthCheck.matchType],
            ['Is response matching by Regex', httpHealthCheck.regex ? 'True' : 'False'],
            ['Response to Match', httpHealthCheck.response],
            ['Negate the response matching', httpHealthCheck.negate ? 'True' : 'False'],
          ]}
          title="Health Check"
        />
      )}

      <hr />

      <Shared.widgets.Section
        sectionTitle="Targets"
        items={targets}
        itemIcon="bullseye"
        setItemTitle={(e) => e.ip}
        setItemDetails={(e) => (
          <>
            {`Port: ${e.port}`}
            <Shared.utilities.Separator />
            {`Weight: ${e.weight}`}
            <Shared.utilities.Separator />
            {(e.healthCheckEnabled) ? 'Health Check Enabled' : 'Health Check disabled'}
          </>
        )}
        tableColumns={['', 'IP', 'Port', '', 'Actions']}
      />
    </Shared.widgets.Page>
  );
};
